import * as React from 'react';
import { RichTextArea } from '@grandvisionhq/common';
import { GlobalContactForm as GlobalContactForm$1 } from '@grandvisionhq/content';
import { useFeatureToggles } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import '@swc/helpers';
import { useBrPageContext } from '../../context/context.js';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../../utils/get-br-page-content.js';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachRichText } from '../../hooks/use-bloomreach-rich-text.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import CmsHeadTags from '../HeadTags/HeadTags.js';

const CmsGlobalContactForm = ({ component , meta  })=>{
    var ref, ref1;
    const page = useBrPageContext();
    const { documentHeader: headerRef , documentFooter: footerRef  } = component.getModels();
    const headerContent = getBrPageContent(page, headerRef[0]);
    const headerRichText = useBloomreachRichText(headerContent === null || headerContent === void 0 ? void 0 : (ref = headerContent.content) === null || ref === void 0 ? void 0 : ref.value);
    const footerContent = getBrPageContent(page, footerRef[0]);
    const footerRichText = useBloomreachRichText(footerContent === null || footerContent === void 0 ? void 0 : (ref1 = footerContent.content) === null || ref1 === void 0 ? void 0 : ref1.value);
    const { country , brand , locale  } = meta;
    const { featureConfigs  } = useFeatureToggles();
    const { globalContactFormUrl  } = featureConfigs;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsHeadTags, null, /*#__PURE__*/ React.createElement("link", {
        rel: "stylesheet",
        href: `${globalContactFormUrl}/styles.css`
    })), /*#__PURE__*/ React.createElement(GlobalContactForm$1, {
        country: country,
        brand: brand,
        locale: locale,
        headerRichText: /*#__PURE__*/ React.createElement(RichTextArea, {
            content: headerRichText
        }),
        footerRichText: /*#__PURE__*/ React.createElement(RichTextArea, {
            content: footerRichText
        })
    }));
};
var GlobalContactForm = compose(withHidableContent, withBloomreachData, withEditableContent)(CmsGlobalContactForm);

export { GlobalContactForm as default };
//# sourceMappingURL=GlobalContactForm.js.map
